import React, { useMemo } from 'react';
import PropTypes, { any } from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { getApiAxiosInstance } from '../../utils/network';
import { paymentProviderTypeIds, regStepIds } from '../../utils/eventConstants';

import { createMemberRegistration, updateMemberRegistration } from '../../api/checkoutEventRegistrationApi';

import EventRegistrationCheckoutFormLegacy from '../EventRegistrationCheckoutFormLegacy';
import CheckoutFormStripe from './CheckoutFormStripe';

import config from '../../../config';
import links from '../../../config/links';

const PaymentStep = (props) => {
    const {
        checkoutRequest,
        stripeAccount,
        isPaid,
        finishPayment,
        event,
        eventFee,
        setPaymentTitle,
        setCheckoutSubmittingFlag,
        setSwitchApiResponse,
        setSwitchTotalRefund,
        toggleSplashBallLoader,
        submitting,
        sidebarFlow,
        switchTotalRefund,
        onCheckoutProcessStarted,
        onPaymentProcessStarted,
        multipleDivisionRegistrations,
        getMultiRegistrationTotal,
        registrationTypeForCamps,
        handleCloseClick,
    } = props;

    const stripePromise = useMemo(() => loadStripe(config.stripeKey, { stripeAccount }), [stripeAccount]);
    const amountInCents = Math.round(eventFee * 100);
    const currency = event?.currency?.abbreviation?.toLowerCase() || 'usd';
    const stripeOptions = { mode: 'payment', currency, amount: amountInCents };

    const paymentProviderTypeId = event.paymentProviderType?.id || event.paymentProviderTypeId;

    const onPaymentMethodCreateFailed = (stripeCardError) => {
        console.log('onPaymentMethodCreateFailed');
        console.log(stripeCardError);
        // todo: do we need to do anything here? maybe not
    };

    const onCheckoutProcessStart = async (checkoutContext) => {
        console.log('onCheckoutProcessStart');
        console.log(checkoutContext);

        const checkoutFunction = sidebarFlow === regStepIds.DIVISIONS_SWITCH ? updateMemberRegistration : createMemberRegistration;

        try {
            const checkoutResult = await checkoutFunction(getApiAxiosInstance(), event.id, { checkoutContext, checkoutRequest });
            const { data } = checkoutResult;
            const { checkoutId } = data;
            onCheckoutProcessStarted(checkoutId);
        } catch (error) {
            // on error from UT_API (or if forwarded from Payments API), show validation/other failure
        }
    };

    const payButtonLabel = `Pay${eventFee > 0 && (` ${event.currency.symbol} ${eventFee.toFixed(2)}`)}`;

    return (
        <div className="row">
            <div className="col mt8">
                <div>
                    {paymentProviderTypeId === paymentProviderTypeIds.STRIPE ? (
                        <Elements stripe={stripePromise} options={stripeOptions}>
                            {event.workflowVersion < 3 ? (
                                <EventRegistrationCheckoutFormLegacy
                                    checkoutRequest={checkoutRequest}
                                    setPaymentTitle={setPaymentTitle}
                                    setCheckoutSubmittingFlag={setCheckoutSubmittingFlag}
                                    setSwitchApiResponse={setSwitchApiResponse}
                                    setSwitchTotalRefund={setSwitchTotalRefund}
                                    toggleSplashBallLoader={toggleSplashBallLoader}
                                    submitting={submitting}
                                    sidebarFlow={sidebarFlow}
                                    switchTotalRefund={switchTotalRefund}
                                    eventFee={eventFee}
                                    paymentProviderCountry={event.club.paymentProviderCountry}
                                    currencySymbol={event.currency.symbol}
                                    currencyAbbreviation={event.currency.abbreviation}
                                    eventId={event.id}
                                    stripePaymentSuccessWrapUp={onPaymentProcessStarted}
                                    multipleDivisionRegistrations={multipleDivisionRegistrations}
                                    getMultiRegistrationTotal={getMultiRegistrationTotal}
                                    registrationTypeForCamps={registrationTypeForCamps}
                                    handleCloseClick={handleCloseClick}
                                />
                            ) : (
                                <CheckoutFormStripe
                                    checkoutRequest={checkoutRequest}
                                    payButtonLabel={payButtonLabel}
                                    onCheckoutProcessStart={onCheckoutProcessStart}
                                    onPaymentMethodCreateFailed={onPaymentMethodCreateFailed}
                                />
                            )}
                        </Elements>
                    ) : (
                        <div className="text-center">
                            <i className="fas fa-exclamation-circle text-danger mb48 mt48 fs40" />
                            <p className="text-bold text-dark mb40">Payment Setup Error</p>
                            <p>Please contact our <a target="_blank" rel="noopener noreferrer" href={links.support}>Support Team</a> for assistance.</p>
                        </div>
                    )}
                </div>
                {isPaid && (
                    <button
                        type="button"
                        className="btn btn-primary btn-xl btn-block text-uppercase mt24"
                        onClick={finishPayment}
                    >
                        Finish
                    </button>
                )}
            </div>
        </div>
    );
};

PaymentStep.propTypes = {
    checkoutRequest: PropTypes.objectOf(any).isRequired,
    stripeAccount: PropTypes.string.isRequired,
    isPaid: PropTypes.bool.isRequired,
    finishPayment: PropTypes.func.isRequired,
    event: PropTypes.objectOf(any).isRequired,
    eventFee: PropTypes.number.isRequired,
    setPaymentTitle: PropTypes.func.isRequired,
    setCheckoutSubmittingFlag: PropTypes.func.isRequired,
    setSwitchApiResponse: PropTypes.func.isRequired,
    setSwitchTotalRefund: PropTypes.func.isRequired,
    toggleSplashBallLoader: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    sidebarFlow: PropTypes.string.isRequired,
    switchTotalRefund: PropTypes.number.isRequired,
    onCheckoutProcessStarted: PropTypes.func.isRequired,
    onPaymentProcessStarted: PropTypes.func.isRequired,
    multipleDivisionRegistrations: PropTypes.objectOf(any).isRequired,
    getMultiRegistrationTotal: PropTypes.func.isRequired,
    registrationTypeForCamps: PropTypes.string.isRequired,
};

PaymentStep.defaultProps = {

};

export default PaymentStep;
